module.exports = __webpack_public_path__ + "static/media/38.8d058714.mp3";